import { showNotification } from '@/modules/notification/engine/notification.library';
import { useEffect, useState } from 'react';
import { X4bEmployeeListItem } from '@/types';
import Container, { Column, FlexWrap, Row } from '@/components/container/Container';
import { TextBodyLarge, TextLabelLarge2 } from '@/components/text/Texts';
import { Checkbox } from 'primereact/checkbox';
import { MdClose } from 'react-icons/md';

type Props = {
	allPeople: X4bEmployeeListItem[];
	peopleToShow: X4bEmployeeListItem[];
	onSelectedPeopleChange: (selectedPeople: X4bEmployeeListItem[]) => void;
};

const AddExistingPeopleForm = ({ allPeople, peopleToShow, onSelectedPeopleChange }: Props) => {
	const [selectedPeopleId, setSelectedPeopleId] = useState<Record<number, boolean>>({});
	const selectedPeople = allPeople.filter(p => selectedPeopleId[p.Id]);

	useEffect(() => {
		onSelectedPeopleChange(selectedPeople);
	}, [selectedPeopleId]);

	const toggleSelection = (person: X4bEmployeeListItem, value?: boolean) =>
		setSelectedPeopleId(prev => ({...prev, [person.Id]: value ?? !prev[person.Id] }));

	const formatName = (fullName: string) => {
		const [firstName, lastName] = fullName.split(' ');
		const formattedFirstName = firstName.charAt(0).toUpperCase() + '.';
		const formattedLastName = lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
		return `${formattedFirstName} ${formattedLastName}`;
	}

	const handleRemove = (person: X4bEmployeeListItem) => {
		toggleSelection(person, false);
		showNotification(`${formatName(person.FullName)} was removed`, undefined, {
			name: 'Undo',
			handler: () => toggleSelection(person, true),
		});
	};

	return (
		<>
			<Container className="h-[226px] overflow-y-auto">
				{peopleToShow.length === 0 && (
					<p className="text-gray-500 py-3 px-4">No available people</p>
				)}
				{peopleToShow.length > 0 && peopleToShow.map((person) => (
					<Row
						key={person.FullName}
						className="items-center justify-between py-3 px-4"
					>
						<Column>
							<TextBodyLarge text={person.FullName} className="text-onSurface" />
							<p className="text-title-small tracking-[0.25px] text-[#49454F]">TODO General/Sales</p>
						</Column>
						<Checkbox
							inputId={`person-checkbox-${person.Id}`}
							checked={selectedPeopleId[person.Id]}
							onChange={() => toggleSelection(person)}
							className="mx-3"
							pt={{ box: {
								className: selectedPeopleId[person.Id]
									? 'bg-primary border-none'
									: 'bg-surfaceContainerHigh border-neutralVariant20'
							}}}
						/>
					</Row>
				))}
			</Container>
			{/* TODO need to save people in order they was selected */}
			{selectedPeople.length > 0 && (
				<FlexWrap className={'flex flex-wrap gap-4 py-3 px-6'}>
					{selectedPeople.map((person) => (
						<Row
							key={person.Id}
							className="gap-2 py-1 pl-3 pr-2 rounded-lg bg-primary99 items-center"
						>
							<TextLabelLarge2 className="text-secondary60" text={formatName(person.FullName)} />
							<MdClose className="cursor-pointer text-secondary60" size={18} onClick={() => handleRemove(person)} />
						</Row>
					))}
				</FlexWrap>
			)}
		</>
	);
};

export default AddExistingPeopleForm;
